import { createContext, PropsWithChildren, useContext } from 'react';

import { Path } from './translationUtils';

interface PathContextData {
    path: Path;
}
const PathContext = createContext<PathContextData>({
    path: [],
});

export const usePathContext = () => {
    const pathContext = useContext(PathContext);
    return pathContext;
};

interface PathContextProviderProps extends PropsWithChildren {
    segment: Path[number];
}
export const PathContextProvider = ({
    children,
    segment,
}: PathContextProviderProps) => {
    const parentPath = useContext(PathContext).path ?? [];
    const newPath =
        segment !== undefined ? [...parentPath, segment] : parentPath;
    return (
        <PathContext.Provider
            value={{
                path: newPath,
            }}
        >
            {children}
        </PathContext.Provider>
    );
};
